export const defaultState = () => {
    return {
        start_id: null
    }
}

const state = defaultState()
export default state